import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import HelpArticleView from '../components/help/HelpArticleView';
import '../components/help/Help.css';

/**
 * Standalone help-article page at /help/<slug>?anchor=...&q=...
 *
 * Thin wrapper around HelpArticleView (shared with the in-drawer view).
 * Adds page-level chrome:
 *   - "Back" — returns to whatever the user was doing before (the SPA's
 *     history back-step). Falls back to /cases if there's no history.
 *   - "All help articles" — sibling navigation to the /help index.
 *   - Internal slug links use react-router so they behave like normal
 *     SPA navigation here (the in-drawer view pushes article state).
 */
export default function HelpDoc() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const anchor = searchParams.get('anchor');
  const queryHighlight = searchParams.get('q');

  const backToCaller = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/cases');
    }
  };

  const SlugLink = ({ slug: targetSlug, children }) => (
    <Link to={`/help/${targetSlug}`}>{children}</Link>
  );

  return (
    <div className="help-doc">
      <div className="help-doc-nav">
        <button className="help-back-to-caller" onClick={backToCaller}>
          ← Back
        </button>
        <Link to="/help" className="help-doc-back">All help articles</Link>
      </div>
      <HelpArticleView
        slug={slug}
        anchor={anchor}
        queryHighlight={queryHighlight}
        viewedInDrawer={false}
        SlugLink={SlugLink}
      />
    </div>
  );
}
